import {
  AppBar,
  AppBarProps,
  Box,
  Button,
  Toolbar,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAuth } from "src/hooks/use-auth";
import { X } from "src/icons/x";
import { upgradePlan } from "src/slices/system/thunks";

interface DashboardTopbarProps extends AppBarProps {
  onOpenSidebar?: () => void;
  onClose?: () => void;
  topBarValues?: any;
  closeCss?: any;
  isUpgradePlan?: boolean;
}

const DashboardTopbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  ...(theme.palette.mode === "light"
    ? {
        boxShadow: theme.shadows[3],
      }
    : {
        backgroundColor: theme.palette.background.paper,
        borderBottomColor: theme.palette.divider,
        borderBottomStyle: "solid",
        borderBottomWidth: 1,
        boxShadow: "none",
      }),
}));

export const DashboardTopbar: FC<DashboardTopbarProps> = (props) => {
  const {
    onOpenSidebar,
    onClose,
    topBarValues,
    closeCss,
    isUpgradePlan,
    ...other
  } = props;
  const dispatch = useDispatch();
  const [offset, setOffset] = useState(0);
  const [stickedToTop, setStickedToTop] = useState(false);
  const { user } = useAuth();
  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    if (offset > 16 && !stickedToTop) {
      setStickedToTop(true);
    }
    if (offset == 0) {
      setStickedToTop(false);
    }
  }, [offset]);

  const redirectToLink = (link) => () => {
    window.open(link, "_blank");
  };
  const upgradeTrialPlan = () => {
    dispatch(upgradePlan());
  };

  return (
    <Box
      sx={{
        paddingBottom: "0px",
        paddingLeft: "0px",
        paddingRight: "0px",
        marginTop: "0px",
        position: "sticky",
        width: "100%",
        zIndex: 99999,
        top: 0,
        transition: "all 0.3s ease-in-out",
      }}
    >
      <DashboardTopbarRoot
        {...other}
        sx={{
          borderRadius: "0px",
          position: "static",
          backgroundColor: "#6A00FF",
          height: "58px",
          paddingLeft: "0px",
          paddingRight: "0px",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            left: 0,
            px: 2,
            height: "45px",
          }}
        >
          <Box display={"flex"} />
          <Box sx={{ flexGrow: 1 }} />
          <Typography
            // variant="h6"

            sx={{
              color: "white",
              fontWeight: "normal",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "16px",
              textOverflow: "wrap",
              fontFamily: "Inter",
            }}
          >
            {topBarValues?.message}
          </Typography>
          {!isUpgradePlan && (
            <Button
              sx={{
                // border: "none",
                outline: "none",
                borderRadius: "10px",
                border: "1px solid",
                // width: "90px",
                height: "45px",

                // borderImageSource:
                //   " linear-gradient(86.04deg,#FFD875 -18.56%, #DA00C8 35.8%, #6A00FF 106.2%)",

                // background:
                //   "linear-gradient(86.04deg,#FFD875 -18.56%, #DA00C8 35.8%, #6A00FF 106.2%)",
                background: "linear-gradient(90deg, #6A00FF 0%, #9800E9 100%)",

                position: "relative",
                zIndex: "1",
                "&::before": {
                  content: "''",
                  position: "absolute",
                  top: "1px",
                  right: "1px",
                  bottom: "1px",
                  left: "1px",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  zIndex: "-1",
                },
                "&::after": {
                  content: `"${topBarValues?.CTA}"`,
                  // background:
                  //   "linear-gradient(86.04deg,#FFD875 -18.56%, #DA00C8 35.8%, #6A00FF 106.2%)",
                  background:
                    "linear-gradient(90deg, #6A00FF 0%, #9800E9 100%)",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                },
                "&:hover": {
                  background:
                    "linear-gradient(90deg, #DA00C8 0%, #9800E9 100%)",
                  "&::before": {
                    backgroundColor: "#fff",
                  },
                  "&::after": {
                    content: `"${topBarValues?.CTA}"`,
                    // background:
                    //   "linear-gradient(86.04deg,#FFD875 -18.56%, #DA00C8 35.8%, #6A00FF 106.2%)",
                    background:
                      "linear-gradient(90deg, #DA00C8 0%, #9800E9 100%)",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  },
                },
                marginLeft: "10px",
              }}
              //styleName: Paragraph/Regular: Bold;

              size="small"
              variant="outlined"
              onClick={
                isUpgradePlan
                  ? upgradeTrialPlan
                  : redirectToLink(topBarValues?.link)
              }
            ></Button>
          )}

          <Box sx={{ flexGrow: 1 }} />
          {!isUpgradePlan && (
            <Box display={"flex"}>
              <X
                sx={{
                  cursor: "pointer",
                }}
                onClick={onClose}
              />
            </Box>
          )}
        </Toolbar>
      </DashboardTopbarRoot>
    </Box>
  );
};

DashboardTopbar.propTypes = {
  onOpenSidebar: PropTypes.func,
  onClose: PropTypes.func,
};
